// extracted by mini-css-extract-plugin
module.exports = {"languageSwitcher":"language-switcher_languageSwitcher__zo4h4","language":"language-switcher_language__hvozI","selected":"language-switcher_selected__xu0_z"};